export enum SideEnum {
    Left = 'A',
    Right = 'B',
}
